import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  AfterContentInit,
  AfterViewInit,
  ViewContainerRef,
  AfterViewChecked
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { LoaderService } from "../../../infrastructure/services/loader.service";
import {AlertService, GrowlType } from "../../../infrastructure/services/alert.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SxContextService } from "../../../infrastructure/services/sxContext.service";
import { EliminarEntidadComponent } from "../../../helpers/components/deleteEntity/deleteEntity.component";
import { SxSecurityService } from "app/infrastructure/services/sxSecurity.service";
import { OrganizationService } from "app/infrastructure/services/organization.service";
import { Organization } from "app/infrastructure/model/classes/organization.class";
import { SxTranslationService } from "app/infrastructure/services/translation-service.service";

@Component({
  templateUrl: "./detalle.organizacion.component.html",
  styleUrls: ['./detalle.organizacion.component.css']
})
export class DetalleOrganizacionComponent {
  @ViewChild(EliminarEntidadComponent)
  eliminarEntidad: EliminarEntidadComponent;

  errors = {};
  isLoading = false;
  editandoImagen = false;
  editarContexto = false;
  descripcion: string;
  url: string;
  preset: string;
  username: string;
  password: string;
  esNuevo = false;
  errorCodigo: string = null;
  checkeandCodigo = false;
  codOrganization: string;
  completitud = 0;
  organizacion: Organization;

  constructor(
    public loader: LoaderService,
    private route: ActivatedRoute,
    private router: Router,
    private contextService: SxContextService,
    private organizationService: OrganizationService,
    private sxTranslationService: SxTranslationService,
    private alertService: AlertService
    ) {}

  ngOnInit() {            
    this.route.params.subscribe(params => {
      this.esNuevo = false;
      this.codOrganization = params["codorganizacion"];

      if (this.codOrganization === undefined) {
        this.esNuevo = true;
        this.organizacion = new Organization();
        return;
      }
      this.organizationService.getOrganization(this.codOrganization, this.checkeandCodigo).subscribe(data => {
        if (!data) {
          return this.router.navigateByUrl("/soc/404");
        }
        this.inicializarCampos(data);
      });
    });
  }

  crearOrganizacion() {
    if (!this.validarCodigo()) {
      return;
    }

    this.checkeandCodigo = true;

    // Check para ver que el codigo de sistema no esta usado
    this.organizationService
      .getOrganization(this.organizacion.organizationCode, this.checkeandCodigo)
      .subscribe(res => {
        this.checkeandCodigo = false;

        // Si el codigo ya existe, no puedo crear un sistema
        if (res !== null) {
          this.errorCodigo = this.sxTranslationService.getResource("CODIGO_EXISTENTE");
          return false;
        }

        // Creo el sistema
        this.organizationService.create(this.organizacion.organizationCode)
          .then(() => {
            this.alertService.showGrowl({
              type: GrowlType.SUCCESS,
              body: "SISTEMA_CREADO_CORRECTAMENTE"
            });
            this.router.navigate([ "../", this.organizacion.organizationCode, "edit"], { relativeTo: this.route });
          });
      });
  }

  ngAfterViewChecked() {
    if (this.eliminarEntidad) {
      this.eliminarEntidad.eliminado.subscribe(eliminado =>
        this.onDelete(eliminado)
      );
    }
  }

  validarCodigo() {
    this.errorCodigo = null;

    if (
      !this.organizacion.organizationCode ||
      this.organizacion.organizationCode.length <= 0
    ) {
      this.errorCodigo = this.sxTranslationService.getResource("AL_MENOS_1_CARACTER");
      return false;
    }

    if (this.organizacion.organizationCode.length > 10) {
      this.errorCodigo = this.sxTranslationService.getResource("MAX_LONGITUD", { max: 10 });
      return false;
    }

    if (this.organizacion.organizationCode === "nuevo") {
      this.errorCodigo = this.sxTranslationService.getResource("CODIGO_INVALIDO");
      return false;
    }
    return true;
  }

  editarDescripcion(nuevoTexto: string) {
    this.organizacion.description = nuevoTexto;
    this.editarSistema({ description: nuevoTexto });
  }

  editarDescripcionExt(nuevoTexto : string) {
    this.organizacion.descriptionExt = nuevoTexto;
    this.editarSistema({ descriptionExt: nuevoTexto });
  }

  //   /**
  //    * Actualiza la Imagen del sistema en el backend
  //    */
  editarImagen(nuevaImagen: any) {
    this.organizacion.UrlImage = nuevaImagen.imagenBase64;
    this.editarSistema({ imagen: nuevaImagen.imagenBase64 });
  }

  onDelete(param) {
    // Reseteamos el CurrentSystem (sistema que acabamos de borrar)
    this.contextService.unloadMemory();
    this.router.navigate(["../../"], { relativeTo: this.route });
  }

  //   ////////////////////////
  //   // Funciones privadas //
  //   ////////////////////////

  private inicializarCampos(data) {
    this.organizacion = data;
    this.camposDeActualizacion(data);
  }

  private esUnContextoValido() {
    this.reiniciarErroresDeContexto();

    const esValidaUrl = this.validarRequiredVarchar(this.url, "url");
    const esValidoPreset = this.validarRequiredVarchar(this.preset, "preset");
    const esValidoUsername = this.validarRequiredVarchar(
      this.username,
      "username"
    );

    return esValidaUrl && esValidoPreset && esValidoUsername;
  }

  //   /**
  //    * Validaciones genéricas para Varchars
  //    *
  //    * @param valor El valor que será validado
  //    * @param campo El campo que se esta validando
  //    * @param presicion La longitud maxima que puede tener el valor
  //    */
  private validarRequiredVarchar(
    valor: string,
    campo: string,
    presicion: number = 255
  ) {
    if (!valor || valor.length <= 0) {
      this.errors[campo] = this.sxTranslationService.getResource("VALOR_REQUERIDO");
      return false;
    }

    if (valor.length > presicion) {
      this.errors[campo] = this.sxTranslationService.getResource("MAX_LONGITUD", { max: presicion });
      return false;
    }

    return true;
  }

  private reiniciarErroresDeContexto() {
    this.errors["url"] = false;
    this.errors["preset"] = false;
    this.errors["username"] = false;
  }

  private editarSistema(newData) {
    this.organizationService
      .editarOrganizacion(this.organizacion.organizationCode, newData)
      .then(res => {
        this.camposDeActualizacion(res);
        this.alertService.showGrowl({
          type: GrowlType.SUCCESS,
          body: "EDITADO_CORRECTAMENTE"
        });
      });
  }

  private camposDeActualizacion(data) {
    this.completitud = data.completitud ? JSON.parse(data.completitud).porcentaje : 0;
    this.organizacion.fechaActualizacion = data.fechaActualizacion;
    this.organizacion.modificado = data.modificado;
    this.organizacion.UrlImage = data.urlImage;
  }

  volver() {
    this.router.navigate(["../"], { relativeTo: this.route });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/organizacion/detalle.organizacion.component.ts